<script>
import {generateUUID, percentage_format, numberWithCommas} from "@/utils.js";
import moment from "moment";
function round(value, precision) {
  var multiplier = Math.pow(10, precision || 0);
  return Math.round(value * multiplier) / multiplier;
}
export default {
  name: "marketing-recommendations",
  props: [
    "marketing_recommendations",
    "form",    
    "isNetworkData",
    "campaignIsSearch",
    "active_tab",
    "timeDimention"
  ],
  data() {
    return {
      hideRecencyRecommendationIncreased: false,
      hideAbsoluteSalesValue:false,
      hideSalesPercentageValue:false,
      hideAbsoluteTrafficValue:false,
      hideTrafficGrowth:false,
      hideAbsoluteFrequency:false,
      hideFrequencyGrowth:false,
      hideAbsoluteAverageCheckValue:false,
      hideAverageCheckGrowth:false
    };
  },
  watch: {
    isNetworkData(){
      this.hideRecencyRecommendationIncreased= false;
      this.hideAbsoluteSalesValue=false;
      this.hideSalesPercentageValue=false;
      this.hideAbsoluteTrafficValue=false;
      this.hideTrafficGrowth=false;
      this.hideAbsoluteFrequency=false;
      this.hideFrequencyGrowth=false;
      this.hideAbsoluteAverageCheckValue=false;
      this.hideAverageCheckGrowth=false;
    },
    marketing_recommendations(){
      this.hideRecencyRecommendationIncreased= false;
      this.hideAbsoluteSalesValue=false;
      this.hideSalesPercentageValue=false;
      this.hideAbsoluteTrafficValue=false;
      this.hideTrafficGrowth=false;
      this.hideAbsoluteFrequency=false;
      this.hideFrequencyGrowth=false;
      this.hideAbsoluteAverageCheckValue=false;
      this.hideAverageCheckGrowth=false;
    },
    active_tab(){
      this.hideRecencyRecommendationIncreased= false;
      this.hideAbsoluteSalesValue=false;
      this.hideSalesPercentageValue=false;
      this.hideAbsoluteTrafficValue=false;
      this.hideTrafficGrowth=false;
      this.hideAbsoluteFrequency=false;
      this.hideFrequencyGrowth=false;
      this.hideAbsoluteAverageCheckValue=false;
      this.hideAverageCheckGrowth=false;
    }
  },
  computed: {
    chartId() {
      return `chart_${generateUUID()}`;
    },
    hasMarketingRecommendations() {
      return this.marketing_recommendations.length > 0;
    },
    averageCheckRecommendation() {
      try {
        let average_check_present =this.marketing_recommendations.find(
          recommendation =>
              recommendation.test_name === "Increase in Average Check"
      );
        if (!average_check_present){
          this.hideAbsoluteAverageCheckValue = true
          this.hideAverageCheckGrowth = true
          return false
          }
      } catch (error) {
        this.hideAbsoluteAverageCheckValue = true
        this.hideAverageCheckGrowth = true
        return false
      }
      return this.marketing_recommendations.find(
          recommendation =>
              recommendation.test_name === "Increase in Average Check"
      );
    },
    averageCheckSelfRecommendation() {
      try {
        let average_check__self_present =this.marketing_recommendations.find(
          recommendation =>
              recommendation.test_name === "Increase in Average Check (self)"
      );
        if (!average_check__self_present){
          this.hideAbsoluteAverageCheckValue = true
          this.hideAverageCheckGrowth = true
          return false
          }
      } catch (error) {
        this.hideAbsoluteAverageCheckValue = true
        this.hideAverageCheckGrowth = true
        return false
      }
      return this.marketing_recommendations.find(
          recommendation =>
              recommendation.test_name === "Increase in Average Check (self)"
      );
    },
    averageCheckRecommendationTestValue() {
      return (
          Math.round(this.averageCheckRecommendation.metric_test_value * 100) /
          100
      );
    },
    // averageCheckRecommendationDiff() {
    //   return (
    //       Math.round(
    //           (this.averageCheckRecommendation.metric_test_value -
    //               this.averageCheckRecommendation.metric_base_value) *
    //           100
    //       ) / 100
    //   );
    // },
    averageCheckPercentVal(){
      return(Math.round(100*(this.averageCheckRecommendation.metric_test_value -
                  this.averageCheckRecommendation.metric_base_value)));
    },
    averageCheckRecommendationDiff() {
      return (
          Math.round(
              (this.averageCheckPercentVal * this.averageCheckSelfRecommendation.metric_test_value)              
          ) / 100
      );
    },
    // averageCheckRecommendationGrowth() {
    //   if (this.averageCheckRecommendation.metric_base_value === 0) {
    //     return this.averageCheckRecommendationDiff;
    //   }
    //   return (
    //       Math.round(
    //           (this.averageCheckRecommendationDiff /
    //               this.averageCheckRecommendation.metric_base_value) *
    //           100 *
    //           100
    //       ) / 100
    //   );      
    // },
    averageCheckRecommendationGrowth() {
      if (this.averageCheckRecommendation.metric_base_value === 0) {
        return this.averageCheckRecommendationDiff;
      }
      return (
          this.averageCheckPercentVal
          );
    },
    averageCheckRecommendationGrowthIncreased() {
      return this.averageCheckRecommendationGrowth > 0;
    },

    increaseInSalesRecommendation() {
      try {
        let increase_in_sales_present =this.marketing_recommendations.find(
          recommendation => recommendation.test_name === "Increase in Sales"
        );  
        if (!increase_in_sales_present){
          this.hideAbsoluteSalesValue = true
          this.hideSalesPercentageValue =true
          return false
          }
      } catch (error) {
        this.hideAbsoluteSalesValue = true
        this.hideSalesPercentageValue =true
        return false
      }
      
      return this.marketing_recommendations.find(
          recommendation => recommendation.test_name === "Increase in Sales"
      );
    },
    increaseInSalesSelfRecommendation() {
      try {
        let increase_in_sales_self_present =this.marketing_recommendations.find(
          recommendation => recommendation.test_name === "Increase in Sales (self)"
        );  
        if (!increase_in_sales_self_present){
          this.hideAbsoluteSalesValue = true
          return false
          }
      } catch (error) {
        this.hideAbsoluteSalesValue = true
        return false
      }
      return this.marketing_recommendations.find(
          recommendation => recommendation.test_name === "Increase in Sales (self)"
      );
    },
    increaseInSalesRecommendationTestValue() {
      try {
        if (!this.increaseInSalesRecommendation) {
          return 0;
        }
        return (
            Math.round(
                this.increaseInSalesRecommendation.metric_test_value * 100
            ) / 100
        );
      } catch (e) {
        return 0;
      }
    },
    formattedIncreaseInSalesRecommendationTestValue() {
      return this.increaseInSalesRecommendationTestValue
          .toString()
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    // increaseInSalesRecommendationDiff() {
    //   return (
    //       Math.round(
    //           (this.increaseInSalesRecommendation.metric_test_value -
    //               this.increaseInSalesRecommendation.metric_base_value) *
    //           100
    //       ) / 100
    //   );
    // },
    increaseInSalesPercentVal(){
      return (
            Math.round(
               100 * (this.increaseInSalesRecommendation.metric_test_value -
                  this.increaseInSalesRecommendation.metric_base_value)
            ) 
        );
    },
    increaseInSalesRecommendationDiff() {
      return (
          Math.round(
             ( this.increaseInSalesPercentVal * this.increaseInSalesSelfRecommendation.metric_test_value)
          ) / 100
      );
    },
    increaseInSalesRecommendationDiffAbs() {
      return Math.abs(this.increaseInSalesRecommendationDiff)
          .toString()
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },

    formattedIncreaseInSalesRecommendationDiff() {
      return Math.abs(this.increaseInSalesRecommendationDiff)
          .toString()
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    // increaseInSalesRecommendationGrowth() {
    //   try {
    //     if (this.increaseInSalesRecommendation.metric_base_value === 0) {
    //       return this.newCustomersRecommendationDiff;
    //     }
    //     return (
    //         Math.round(
    //             (this.increaseInSalesRecommendationDiff /
    //                 this.increaseInSalesRecommendation.metric_base_value) *
    //             100 *
    //             100
    //         ) / 100
    //     );
    //   } catch (e) {
    //     return 0;
    //   }
    // },
    increaseInSalesRecommendationGrowth() {
      try {
        if (this.increaseInSalesRecommendation.metric_base_value === 0) {
          return this.newCustomersRecommendationDiff;
        }
        return (
            this.increaseInSalesPercentVal
        );
      } catch (e) {
        return 0;
      }
    },
    increaseInSalesRecommendationIncreased() {
      return this.increaseInSalesRecommendationGrowth > 0;
    },

    newCustomersRecommendation() {
      // try {
      //   let mc_traffic_local_market_present =this.marketing_recommendations.find(
      //     recommendation => recommendation.test_name === "mc_traffic_local_market"
      //   );  
      //   if (!mc_traffic_local_market_present){
      //     this.hideAbsoluteTrafficValue = true          
      //     this.hideTrafficGrowth = true
      //     return false
      //     }
      // } catch (error) {
      //   this.hideAbsoluteTrafficValue = true
      //   this.hideTrafficGrowth = true
      //   return false
      // }
      return this.marketing_recommendations.find(
          recommendation => recommendation.test_name === "mc_traffic_local_market"
      );
    },
    newCustomersRecommendationTestValue() {
      if (!this.newCustomersRecommendation) {
        return 0;
      }
      return numberWithCommas(
          Math.round(this.newCustomersRecommendation.metric_test_value * 100) /
          100
      );
    },
    newCustomersRecommendationDiff() {
      if (!this.newCustomersRecommendation) {
        return 0;
      }
      return (
          Math.round(
              (this.newCustomersRecommendation.metric_test_value -
                  this.newCustomersRecommendation.metric_base_value) *
              100
          ) / 100
      );
    },
    formattedNewCustomersRecommendationDiff() {
      return Math.round(Math.abs(this.newCustomersRecommendationDiff))
          .toString()
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    newCustomersRecommendationDiffAbs() {
      return Math.abs(this.newCustomersRecommendationDiff)
          .toString()
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    newCustomersRecommendationGrowth() {
      if (!this.newCustomersRecommendation) {
        return 0;
      }
      try {
        if (this.newCustomersRecommendation.metric_base_value === 0) {
          return this.newCustomersRecommendationDiff;
        }
        return (
            Math.round(
                (this.newCustomersRecommendationDiff /
                    this.newCustomersRecommendation.metric_base_value) *
                100 *
                100
            ) / 100
        );
      } catch (e) {
        return 0;
      }
    },
    formattedNewCustomersRecommendationGrowth() {
      return Math.abs(this.newCustomersRecommendationGrowth)
          .toString()
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    newCustomersRecommendationIncreased() {
      return this.newCustomersRecommendationGrowth > 0;
    },
    trafficRecommendation() {
      try {
        let traffic_present =this.marketing_recommendations.find(
          recommendation => recommendation.test_name === "Traffic"
        );  
        if (!traffic_present){
          this.hideAbsoluteTrafficValue = true;          
          this.hideTrafficGrowth = true;
          return false
          }
      } catch (error) {
          this.hideAbsoluteTrafficValue = true;          
          this.hideTrafficGrowth = true;
        return false
      }
      return this.marketing_recommendations.find(
          recommendation => recommendation.test_name === "Traffic"
      );
    },
    trafficSelfRecommendation() {
      try {
        let traffic_self_present =this.marketing_recommendations.find(
          recommendation => recommendation.test_name === "Traffic (self)"
        );  
        if (!traffic_self_present){
          this.hideAbsoluteTrafficValue = true;          
          this.hideTrafficGrowth = true;
          return false
          }
      } catch (error) {
          this.hideAbsoluteTrafficValue = true;          
          this.hideTrafficGrowth = true;
        return false
      }
      return this.marketing_recommendations.find(
          recommendation => recommendation.test_name === "Traffic (self)"
      );
    },
    trafficRecommendationTestValue() {
      if (
          !this.trafficRecommendation ||
          typeof this.trafficRecommendation === "undefined"
      ) {
        return 0;
      }
      return numberWithCommas(
          Math.round(this.trafficRecommendation.metric_test_value * 100) / 100
      );
    },
    // trafficRecommendationDiff() {
    //   if (
    //       !this.trafficRecommendation ||
    //       typeof this.trafficRecommendation === "undefined"
    //   ) {
    //     return 0;
    //   }
    //   return (
    //       Math.round(
    //           (this.trafficRecommendation.metric_test_value -
    //               this.trafficRecommendation.metric_base_value) *
    //           100
    //       ) / 100
    //   );
    // },   
    
    
    trafficPercentVal(){
      return (
            round(
              (100*  (this.trafficRecommendation.metric_test_value -
                  this.trafficRecommendation.metric_base_value)),1 
            )
        );
    },
    trafficRecommendationDiff() {
      if (
          !this.trafficRecommendation ||
          typeof this.trafficRecommendation === "undefined"
      ) {
        return 0;
      }
      return (
          Math.round(
             ( this.trafficPercentVal *this.trafficSelfRecommendation.metric_test_value)
              
          ) / 100
      );
    },
    trafficRecommendationDiffAbs() {
      return Math.round(Math.abs(this.trafficRecommendationDiff))
          .toString()
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    trafficThresholdCheck(){
      if (Math.round(Math.abs(this.trafficRecommendationDiff)) > 0){
        return true;
      }        
      else {
        return false;
      }

    },
    // trafficRecommendationGrowth() {
    //   try {
    //     if (this.trafficRecommendation.metric_base_value === 0) {
    //       return this.trafficRecommendationDiff;
    //     }
    //     return (
    //         Math.round(
    //             (this.trafficRecommendationDiff /
    //                 this.trafficRecommendation.metric_base_value) *
    //             100 *
    //             100
    //         ) / 100
    //     );
    //   } catch (e) {
    //     return 0;
    //   }
    // },
    trafficRecommendationGrowth() {
      try {
        if (this.trafficRecommendation.metric_base_value === 0) {
          return this.trafficRecommendationDiff;
        }
        return (
           this.trafficPercentVal
        );
      } catch (e) {
        return 0;
      }
    },
    
    trafficRecommendationIncreased() {
      return this.trafficRecommendationGrowth > 0;
    },
    frequencyRecommendation() {
      try {
        let frequency_present =this.marketing_recommendations.find(
          recommendation =>
              recommendation.test_name === "Increase in Frequency"
      );
        if (!frequency_present){
          this.hideAbsoluteFrequency = true
          this.hideFrequencyGrowth = true
          return false
          }
      } catch (error) {
        this.hideAbsoluteFrequency = true
        this.hideFrequencyGrowth = true
        return false
      }
      return this.marketing_recommendations.find(
          recommendation =>
              recommendation.test_name === "Increase in Frequency"
      );
    },
    frequencySelfRecommendation() {
       try {
        let frequency_self_present =this.marketing_recommendations.find(
          recommendation =>
              recommendation.test_name === "Increase in Frequency (self)"              
      );
        if (!frequency_self_present){
          this.hideFrequencyGrowth = true
          return false
          }
      } catch (error) {
        this.hideFrequencyGrowth = true
        return false
      }
      return this.marketing_recommendations.find(
          recommendation =>
              recommendation.test_name === "Increase in Frequency (self)"
      );
    },
    hasFrequencyRecommendation() {
      return !!this.frequencyRecommendation;
    },
    frequencyRecommendationTestValue() {
      try {
        if (!this.frequencyRecommendation) {
          return 0;
        }
        return (
            Math.abs(Math.round(this.frequencyRecommendation.metric_test_value * 100) / 100)
        );
      } catch (e) {
        return 0;
      }
    },
    // frequencyRecommendationDiff() {
    //   if (!this.frequencyRecommendation) {
    //     return 0;
    //   }
    //   return (
    //       Math.round(
    //           (this.frequencyRecommendation.metric_test_value -
    //               this.frequencyRecommendation.metric_base_value) *
    //           100
    //       ) / 100
    //   );
    // },
    frequencyPercentVal(){
      return (
          Math.round(
              100*(this.frequencyRecommendation.metric_test_value -
                  this.frequencyRecommendation.metric_base_value)
          ) 
      );
    },
    frequencyRecommendationDiff() {
      if (!this.frequencyRecommendation) {
        return 0;
      }
      return (
          Math.round(
            ( this.frequencyPercentVal * this.frequencySelfRecommendation.metric_test_value)
          )/100 
      );
    },
    // frequencyRecommendationGrowth() {
    //   if (!this.frequencyRecommendation) {
    //     return 0;
    //   }
    //   if (this.frequencyRecommendation.metric_base_value === 0) {
    //     return this.frequencyRecommendationDiff;
    //   }
    //   return (
    //       Math.round(
    //           (this.frequencyRecommendationDiff /
    //               this.frequencyRecommendation.metric_base_value) *
    //           100 *
    //           100
    //       ) / 100
    //   );
    // },
    frequencyRecommendationGrowth() {
      if (!this.frequencyRecommendation) {
        return 0;
      }
      if (this.frequencyRecommendation.metric_base_value === 0) {
        return this.frequencyRecommendationDiff;
      }
      return (
          this.frequencyPercentVal
      );
    },
    frequencyRecommendationIncreased() {
      return this.frequencyRecommendationGrowth > 0;
    },
    frequencyRecommendationDiffAbs() {
      return Math.abs(this.frequencyRecommendationDiff)
          .toString()
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    recencyRecommendation() {
      try {
        let recency_present =this.marketing_recommendations.find(
          recommendation =>
              recommendation.test_name === "Decrease in Recency"
      );
        if (!recency_present){
          this.hideRecencyRecommendationIncreased = true
          return false
          }
      } catch (error) {
        this.hideRecencyRecommendationIncreased = true
        return false
      }
      return this.marketing_recommendations.find(
          recommendation =>
              recommendation.test_name === "Decrease in Recency"
      );
    },
    recencySelfRecommendation() {
      return this.marketing_recommendations.find(
          recommendation =>
              recommendation.test_name === "Decrease in Recency (self)"
      );
    },
    hasRecencyRecommendation() {
      return !!this.recencyRecommendation;
    },
    recencyRecommendationTestValue() {
      return (
          Math.round(this.recencyRecommendation.metric_test_value * 100) / 100
      );
    },
    // recencyRecommendationDiff() {
    //   return (
    //       Math.round(
    //           (this.recencyRecommendation.metric_test_value -
    //               this.recencyRecommendation.metric_base_value) *
    //           100
    //       ) / 100
    //   );
    // },
    recencyPercentVal(){
      return (
          Math.round(
              100 * (this.recencyRecommendation.metric_test_value -
                  this.recencyRecommendation.metric_base_value)
          ) 
      );
    },
    recencyRecommendationDiff() {
      try {
        if (!this.recencySelfRecommendation && !this.recencySelfRecommendation.metric_test_value){
          this.hideRecencyRecommendationIncreased = true
          return false
          }
      } catch (error) {
        this.hideRecencyRecommendationIncreased = true
        return false
      }
      return (
          Math.round(
            ( this.recencyPercentVal * this.recencySelfRecommendation.metric_test_value)
          ) / 100
      );
    },
    // recencyRecommendationGrowth() {
    //   if (!this.recencyRecommendation) {
    //     return 0;
    //   }
    //   if (this.recencyRecommendation.metric_base_value === 0) {
    //     return this.recencyRecommendationDiff;
    //   }
    //   return (
    //       Math.round(
    //           (this.recencyRecommendationDiff /
    //               this.recencyRecommendation.metric_base_value) *
    //           100 *
    //           100
    //       ) / 100
    //   );
    // },
    recencyRecommendationGrowth() {
      if (!this.recencyRecommendation) {
        return 0;
      }
      if (this.recencyRecommendation.metric_base_value === 0) {
        return this.recencyRecommendationDiff;
      }
      return (
          this.recencyPercentVal
      );
    },
    recencyRecommendationIncreased() {
      return this.recencyRecommendationGrowth > 0;
    },
    recencyRecommendationDiffAbs() {
      return Math.abs(this.recencyRecommendationDiff)
          .toString()
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
  },
  mounted() {
  },
  methods: {
    displayMoneyFormatAmount(value) {
      // Convert to String
      let total_string = "" + value;
      // Convert to number and remove comma
      let total_num = parseFloat(total_string.replace(/,/g, ""));
      if (total_num < 0) {
        let x = total_num.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, "$&,");
        return "$" + Math.abs(x);
      }
      return "$" + total_num.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, "$&,");
    },
    getAbsValue(value){
      return Math.abs(value);
    }
  }
};
</script>

<template>
  <div class="marketing-recom-div">
    <v-card class="no-shadow">
      <div class="alert-con">
        <v-alert
          outlined
          type="info"
          text
          class="outer-container mt-3 mb-3"
          v-if="hasMarketingRecommendations"
        >
          The below metrics are calculated against the performance of the {{active_tab.replaceAll('-',' ')}} around the stores where you ran your campaign.
        </v-alert>
        <v-alert
            outlined
            type="info"
            text
            class="outer-container"
            v-if="!hasMarketingRecommendations"
        >
          No marketing recommendations are available for this campaign.
        </v-alert>
      </div>
      <v-row class="mb-1" v-if="hasMarketingRecommendations">
        <v-col md="4">
          <v-card class="mx-auto min-card-height card-con" max-width="350">
            <v-card-title>
              SALES
            </v-card-title>
            <v-card-text v-if="!campaignIsSearch">
              <v-container fluid>
                <v-progress-circular
                        indeterminate
                        color="primary"
                ></v-progress-circular>
              </v-container>
            </v-card-text>
            <v-card-text v-if="campaignIsSearch">
              <div class="d-flex flex-column align-items-start mt-n3">
                <span v-if="!hideAbsoluteSalesValue">
                  <p 
                  v-if="increaseInSalesRecommendationIncreased"
                  class="text-h3 blue--text font-weight-bold">
                    +{{
                      displayMoneyFormatAmount(
                          formattedIncreaseInSalesRecommendationDiff
                      )
                    }}
                  </p>
                  <p 
                  v-if="!increaseInSalesRecommendationIncreased"
                  class="text-h3 blue--text font-weight-bold">
                    -{{
                      displayMoneyFormatAmount(
                          formattedIncreaseInSalesRecommendationDiff
                      )
                    }}
                  </p>
                </span>
                <span v-if="!hideSalesPercentageValue">
                  <p
                      class="ml-2 text-h5 font-weight-bold green--text"
                      v-if="increaseInSalesRecommendationIncreased"
                  >
                    +{{ getAbsValue(increaseInSalesRecommendationGrowth) }}%
                  </p>
                  <p
                      class="ml-2 text-h5 font-weight-bold red--text"
                      v-if="!increaseInSalesRecommendationIncreased"
                  >
                    -{{ getAbsValue(increaseInSalesRecommendationGrowth) }}%
                  </p>
                </span>
              </div>
              <div
                  class="text--primary mt-n2"
                  v-if="increaseInSalesRecommendationIncreased && (!hideAbsoluteSalesValue || !hideSalesPercentageValue)"
              >
                Your campaign increased sales by
                
                <span class="font-weight-bold green--text">
                  <span v-if="!hideAbsoluteSalesValue">
                  {{
                    displayMoneyFormatAmount(
                        formattedIncreaseInSalesRecommendationDiff
                    )
                  }}
                  </span>
                  <span v-if="!hideAbsoluteSalesValue && !hideSalesPercentageValue" class=" font-weight-thin black--text">or</span>
                  <span v-if="!hideSalesPercentageValue">
                    {{ getAbsValue(increaseInSalesRecommendationGrowth) }}%
                  </span>
                </span>
                compared to your {{active_tab.replaceAll('-',' ')}}.
              </div>
              
              <div
                  class="text--primary mt-n2"
                  v-if="!increaseInSalesRecommendationIncreased && (!hideAbsoluteSalesValue || !hideSalesPercentageValue)"
              >
                Your campaign decreased sales by
                <span class="font-weight-bold red--text">
                  <span v-if="!hideAbsoluteSalesValue">
                  {{
                    displayMoneyFormatAmount(
                        formattedIncreaseInSalesRecommendationDiff
                    )
                  }}                  
                  </span>
                  <span v-if="!hideAbsoluteSalesValue && !hideSalesPercentageValue">or</span>
                  <span v-if="!hideSalesPercentageValue">
                    {{ getAbsValue(increaseInSalesRecommendationGrowth) }}%
                  </span>
                </span>
                compared to your {{active_tab.replaceAll('-',' ')}}.                
              </div>
              <span v-if="hideAbsoluteSalesValue && hideSalesPercentageValue">No meaningful change in sales.</span>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col md="4">
          <v-card class="mx-auto min-card-height card-con" max-width="350" >
            <v-card-title>
              TRAFFIC
            </v-card-title>
            <v-card-text v-if="!campaignIsSearch">
              <v-container fluid>
                <v-progress-circular
                        indeterminate
                        color="primary"
                ></v-progress-circular>
              </v-container>
            </v-card-text>
            <v-card-text v-if="campaignIsSearch">
              <div class="d-flex align-items-center mt-n3">
                <p 
                v-if="trafficRecommendationIncreased"
                class="text-h3 blue--text font-weight-bold">
                  <span v-if="!hideAbsoluteTrafficValue && trafficThresholdCheck">
                    
                  +{{ trafficRecommendationDiffAbs }}
                  </span>
                </p>
                <p 
                v-if="!trafficRecommendationIncreased"
                class="text-h3 blue--text font-weight-bold">
                  <span v-if="!hideAbsoluteTrafficValue && trafficThresholdCheck">
                    
                  -{{ trafficRecommendationDiffAbs }}
                  </span>
                </p>
                
                <p
                    class="ml-2 text-h5 font-weight-bold green--text"
                    v-if="trafficRecommendationIncreased"
                >
                  <span v-if="!hideTrafficGrowth && trafficThresholdCheck">
                    +{{ getAbsValue(trafficRecommendationGrowth) }}%
                  </span>
                </p>
                <p
                    class="ml-2 text-h5 font-weight-bold red--text"
                    v-if="!trafficRecommendationIncreased"
                >
                  <span v-if="!hideTrafficGrowth && trafficThresholdCheck ">
                    -{{ getAbsValue(trafficRecommendationGrowth) }}%
                  </span>
                </p>
              </div>
              <div class="text--primary mt-n2">
                  <span v-if="trafficRecommendationIncreased && (!hideAbsoluteTrafficValue || !hideTrafficGrowth  ) && trafficThresholdCheck" >
                    Your campaign increased customers by
                    
                    <span  class="font-weight-bold green--text">
                      <span v-if="!hideAbsoluteTrafficValue && trafficThresholdCheck">
                      {{ trafficRecommendationDiffAbs }}                      
                      </span>
                      <span v-if="!hideAbsoluteTrafficValue && !hideTrafficGrowth && trafficThresholdCheck " class=" font-weight-thin black--text">or</span>
                      <span v-if="!hideTrafficGrowth && trafficThresholdCheck">
                      {{ getAbsValue(trafficRecommendationGrowth) }}%
                      </span>
                    </span>
                  </span>
                 <span v-if="!trafficRecommendationIncreased && (!hideAbsoluteTrafficValue || !hideTrafficGrowth ) && trafficThresholdCheck" >
                   Your campaign decrease customers by
                    <span class="font-weight-bold red--text" >
                      <span v-if="!hideAbsoluteTrafficValue && trafficThresholdCheck">                   
                      {{ trafficRecommendationDiffAbs }}
                      
                      </span>
                      <span v-if="!hideAbsoluteTrafficValue && !hideTrafficGrowth && trafficThresholdCheck" class=" font-weight-thin black--text">or</span>
                      <span v-if="!hideTrafficGrowth && trafficThresholdCheck">
                      {{ getAbsValue(trafficRecommendationGrowth) }}%
                      </span>
                    </span>
                  </span>                  
                <span v-if="hideAbsoluteTrafficValue && hideTrafficGrowth || !trafficThresholdCheck">No meaningful change in traffic</span>
                <span v-if="frequencyRecommendationIncreased &&(!hideAbsoluteFrequency || !hideFrequencyGrowth )">
                  , increased frequency by
                  <!-- <span v-if="!hideAbsoluteFrequency">
                    <span class="font-weight-bold green--text">{{
                        frequencyRecommendationDiffAbs
                      }}</span>
                    visits per month
                  </span>
                  <span v-if="!hideAbsoluteFrequency && !hideFrequencyGrowth"> or </span> -->
                  <span v-if="!hideFrequencyGrowth">
                    <span class="font-weight-bold green--text"
                    >{{ getAbsValue(frequencyRecommendationGrowth) }}%</span
                    >
                  </span>
                </span>

                <span v-if="!frequencyRecommendationIncreased &&(!hideAbsoluteFrequency || !hideFrequencyGrowth )">
                  , decreased frequency by
                  <span v-if="!hideAbsoluteFrequency">
                    <span class="font-weight-bold red--text">{{
                        frequencyRecommendationDiffAbs
                      }}</span>
                    visits per month
                  </span>
                  <span v-if="!hideAbsoluteFrequency && !hideFrequencyGrowth"> or </span>
                  <span v-if="!hideFrequencyGrowth">
                    <span class="font-weight-bold red--text">{{ getAbsValue(frequencyRecommendationGrowth) }}%</span>
                  </span>
                </span>
                <span v-if="hideAbsoluteFrequency && hideFrequencyGrowth">, no meaningful change in frequency </span>
                <span v-if="hideRecencyRecommendationIncreased">
                  , no meaningful change in recency.
                </span>
                <span v-if="!hideRecencyRecommendationIncreased">
                  <!-- <span v-if="recencyRecommendationIncreased && (recencyRecommendation.metric_base_value === 0 && recencySelfRecommendation)"> -->
                  <span v-if="recencyRecommendationIncreased">
                    , and increased recency by
                    <span class="font-weight-bold red--text">{{
                        recencyRecommendationDiffAbs
                      }}</span>
                    days or
                    <span class="font-weight-bold red--text"
                    >{{ getAbsValue(recencyRecommendationGrowth) }}%</span
                    >
                    compared to your {{active_tab.replaceAll('-',' ')}}.
                  </span>
                  <!-- <span v-if="!recencyRecommendationIncreased && (recencyRecommendation.metric_base_value === 0 && recencySelfRecommendation)"> -->
                  <span v-if="!recencyRecommendationIncreased">
                    , and decreased recency by
                    <span class="font-weight-bold green--text">{{
                        recencyRecommendationDiffAbs
                      }}</span>
                    days or
                    <span class="font-weight-bold green--text"
                    >{{ getAbsValue(recencyRecommendationGrowth) }}%</span
                    >
                    compared to your {{active_tab.replaceAll('-',' ')}}.
                  </span>
                </span>
              </div>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col md="4">
          <v-card class="mx-auto min-card-height card-con" max-width="350" >
            <v-card-title>
              AVERAGE CHECK
            </v-card-title>
            <v-card-text v-if="!campaignIsSearch">
              <v-container fluid>
                <v-progress-circular
                        indeterminate
                        color="primary"
                ></v-progress-circular>
              </v-container>
            </v-card-text>
            <v-card-text v-if="campaignIsSearch">
              <div class="d-flex align-items-center mt-n3">
                <!-- <p class="text-h3 blue--text font-weight-bold">
                  {{
                    displayMoneyFormatAmount(averageCheckRecommendationTestValue)
                  }}
                </p> -->
                <p
                    class="text-h3 blue--text font-weight-bold"
                    v-if="averageCheckRecommendationGrowthIncreased"
                >
                  <span v-if="!hideAbsoluteAverageCheckValue">
                  +{{ displayMoneyFormatAmount(averageCheckRecommendationDiff) }}
                  </span>
                </p>
                <p
                    class="text-h3 blue--text font-weight-bold"
                    v-if="!averageCheckRecommendationGrowthIncreased"
                >
                  <span v-if="!hideAbsoluteAverageCheckValue">
                  -{{ displayMoneyFormatAmount(averageCheckRecommendationDiff) }}
                  </span>
                </p>
                <p
                    class="ml-2 text-h5 font-weight-bold green--text"
                    v-if="averageCheckRecommendationGrowthIncreased"
                >
                  <span v-if="!hideAverageCheckGrowth">
                  +{{ getAbsValue(averageCheckRecommendationGrowth) }}%
                  </span>
                </p>
                <p
                    class="ml-2 text-h5 font-weight-bold red--text"
                    v-if="!averageCheckRecommendationGrowthIncreased"
                >
                  <span v-if="!hideAverageCheckGrowth">
                  -{{ getAbsValue(averageCheckRecommendationGrowth) }}%
                  </span>
                </p>
              </div>
              <div
                  class="text--primary mt-n2"
                  v-if="averageCheckRecommendationGrowthIncreased && (!hideAbsoluteAverageCheckValue || !hideAverageCheckGrowth)"
              >
                Your campaign increased average check by
                <span class="font-weight-bold green--text">
                  <span v-if="!hideAbsoluteAverageCheckValue">
                  {{ displayMoneyFormatAmount(averageCheckRecommendationDiff) }}
                  </span>
                  <span v-if ="!hideAbsoluteAverageCheckValue && !hideAverageCheckGrowth" class=" font-weight-thin black--text"> or </span>
                  <span v-if="!hideAverageCheckGrowth">
                  {{ getAbsValue(averageCheckRecommendationGrowth) }}%
                  </span>
                </span>
                compared to your {{active_tab.replaceAll('-',' ')}}.
              </div>
              <div
                  class="text--primary mt-n2"
                  v-if="!averageCheckRecommendationGrowthIncreased && (!hideAbsoluteAverageCheckValue || !hideAverageCheckGrowth)"
              >
                Your campaign decreased average check by
                <span class="font-weight-bold red--text">
                  <span v-if="!hideAbsoluteAverageCheckValue">
                  {{
                    displayMoneyFormatAmount(averageCheckRecommendationDiff)
                  }}
                  </span>
                  <span v-if ="!hideAbsoluteAverageCheckValue && !hideAverageCheckGrowth" class=" font-weight-thin black--text"> or </span>
                  <span v-if="!hideAverageCheckGrowth">
                  {{ getAbsValue(averageCheckRecommendationGrowth) }}%
                  </span>
                </span>
                compared to your {{active_tab.replaceAll('-',' ')}}.
              </div>
              <span v-if="hideAbsoluteAverageCheckValue && hideAverageCheckGrowth">No meaningful change in average check </span>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-card>    
    
  </div>
</template>

<style>
.absolute-val-css .blue--text,
.absolute-val-css .green--text,
.absolute-val-css .red--text,

.absolute-val-css p,
.absolute-val-css div{
  color:#cdced5 !important
  
}
.marketing-recom-div .no-shadow{
  box-shadow: none !important;
}
.marketing-recom-div .min-card-height{
  min-height: 210px;
}

.alert-con{
  padding: 0px 8px;
}

.marketing-recom-div .card-con{
  box-shadow: none !important;
  border: 1px solid #2197f363;
  border-radius: 15px;
}
</style>